import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails
} from '../../interfaces/apiInterfaces';

export class GetDriverByIdCommand extends IRequestCommand<
  IGetDriverByIdResponse,
  ErrorDetails,
  IGetDriverByIdCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'drivers/{id}';
  public override setParameters(parameters: IGetDriverByIdCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{id}',
      parameters.idDriver.toString()
    );
  }
}

export interface IGetDriverByIdCommandParameters extends ICommandParameters {
  idDriver?: number;
}

export interface IGetDriverByIdResponse extends ICommandResponse { }
